module.exports = "https://static.operabase.net/642614a3-e761-41e7-947b-3e0067479651/_next/static/images/cueTvIcon-aab68c909ebfcf7a387cb99871806bd1.svg";